import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HomePageHeader from "./HomePageHeader";
import AuthFooter from "../../components/AuthFooter/AuthFooter";
import Login from "../../components/forms/Login";
import "../../assets/css/styles.css";
import "../../assets/css/patients.css";

import PhysicianSignUpImage from "../../assets/images/physician-sign-up-image.png";
import PatientSignUpImage from "../../assets/images/patient-sign-up-image.png";

export default function Landing() {
  const [showingOtp, setShowingOtp] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="auth-background">
      <HomePageHeader />
      <div className="relative w-full flex flex-grow justify-center overflow-hidden md:mt-16">
        <div className="relative z-10 flex items-center justify-center md:py-12 px-4">
          <div className="w-full max-w-[676px]">
            {/* Login Card */}
            <div className="bg-cream rounded-[20px] py-8 px-4 md:py-5 md:px-3 shadow-xl">
              <div className="space-y-4 md:px-9 md:pt-4">
                <Login onOtpStateChange={setShowingOtp} />
              </div>

              {/* Bottom sections - Hidden when showing OTP */}
              {!showingOtp && (
                <>
                  <div className="mt-8 text-center bg-[#F6E9E1] p-[14px] rounded">
                    <p className="text-black">
                      Do you have a <strong>Docnote Debit</strong> request that you need to pay for? Click{" "}
                      <Link to="/guest/login" className="font-medium underline">
                        HERE
                      </Link>
                      .
                    </p>
                  </div>

                  <div className="mt-6 py-5 px-8 bg-[#F6E9E1] rounded">
                    <h3 className="text-center text-[22px] font-bold mb-7 font-inter">Sign Up</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                      {/* Physicians Card */}
                      <Link
                        to="/"
                        className="group relative bg-[#D8E8F6] border border-navy-blue/50 rounded-lg px-3 flex items-center gap-10 cursor-pointer"
                      >
                        <div className="flex-shrink-0 w-[74px] h-[102px] rounded-lg overflow-hidden">
                          <img src={PhysicianSignUpImage} alt="Physician" className="w-full h-full object-cover" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-[18px] font-bold mb-0.5">Medical Practitioners</h4>
                          <p className="font-bold font-inter">Sign up here →</p>
                        </div>
                      </Link>

                      {/* Patients Card */}
                      <Link
                        to="/patient"
                        className="group relative bg-[#E6D8F6] border border-navy-blue/50 rounded-lg px-3 flex items-center gap-4 cursor-pointer"
                      >
                        <div className="flex-shrink-0 w-[94px] h-[110px] rounded-lg overflow-hidden">
                          <img src={PatientSignUpImage} alt="Patient" className="w-full h-full object-cover" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-[18px] font-bold text-navy-blue mb-0.5">Patients</h4>
                          <p className="font-bold font-inter">Sign up here →</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mt-10 bg-[#111C3D] border-t border-white/20 ">
        <AuthFooter extraClasses={"footerContainer mx-auto"} />
      </div> */}
    </div>
  );
}
